<template>
  <div id="source_permission_data" v-loading="loadingTree">
    <!-- 中间树结构 -->
    <div class="tree_content h100">
      <div class="left_tree_box center_tree_box bg-F9 h100 pt-3">
        <div class="pl-4 pr-4">
          <el-input
            v-model="centerSearchText"
            class="self-filter-input"
            placeholder="搜索"
            clearable
            @keyup.enter.native="filterTree"
            @input="filterTree"
            @clear="filterTree"
          >
            <i slot="suffix" class="pr-1" @click="filterTree">
              <svg-icon icon-class="input_search" class="cursor-pointer"></svg-icon>
            </i>
          </el-input>
        </div>
        <div class="flex justify-between">
          <div class="pl-4">
            <span class="vertical-bar fnM">对象列表</span>
          </div>

          <div class="pr-4 sicm-sub-text-color text-gray-901">
            <span class="cursor-pointer hover:text-primary" @click="expandTree(true)">展开</span>
            <span class="pr-2 pl-2">|</span>
            <span class="cursor-pointer hover:text-primary" @click="expandTree(false)">收起</span>
          </div>
        </div>
        <div class="overflow-y-scroll tree_height mt-2 pb-1">
          <el-tree
            ref="centerTree"
            class="self-tree data_tree"
            node-key="id"
            :props="defaultProps"
            :data="treeData"
            :highlight-current="true"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            @node-expand="handleNodeExpand"
            @node-collapse="handleNodeCollapse"
          >
            <span slot-scope="{ node }" class="self-custom-tree leading-8">
              <span
                :class="node.isCurrent ? '' : node.data.resourceType === 0 ? 'text-blue-3377' : ''"
              >
                {{ node.label
                }}{{ node.data.dataScopeTypeName ? `(${node.data.dataScopeTypeName})` : '' }}
              </span>
            </span>
          </el-tree>
        </div>
      </div>

      <!-- 右边内容 -->
      <div class="right_content mt-3">
        <div class="clearfix">
          <el-button
            v-if="!disabled"
            type="primary"
            :loading="saving"
            class="w-20 float-right"
            :disabled="commonResource.dataScopeType === ''"
            @click="handleConfrimSave()"
          >
            保存
          </el-button>
        </div>
        <div v-loading="loadingQuick" class="content_box mt-3 border-solid border-EB border flex">
          <div class="h-full w-1/3 border-solid border-EB border-r pl-4">
            <div class="pt-4 pb-2 scim-text-color fn14">选择数据集查看方式</div>
            <el-radio-group v-model="commonResource.dataScopeType" class="flex-col">
              <el-radio
                v-for="scope in scopeList"
                :key="Object.keys(scope)[0]"
                :disabled="disabled"
                :label="Object.keys(scope)[0]"
              >
                {{ Object.values(scope)[0] }}
              </el-radio>
            </el-radio-group>
          </div>
          <div class="h-full w-2/3">
            <div v-if="commonResource.dataScopeType === 'TRANS_DEPT'" class="h100">
              <div class="pl-4 pr-4 w-2/5 pt-3">
                <el-input
                  v-model="departSearchText"
                  class="self-filter-input"
                  placeholder="搜索"
                  clearable
                  @keyup.enter.native="filterDepartTree"
                  @input="filterDepartTree"
                  @clear="filterDepartTree"
                >
                  <i slot="suffix" class="pr-1" @click="filterDepartTree">
                    <svg-icon icon-class="input_search" class="cursor-pointer"></svg-icon>
                  </i>
                </el-input>
              </div>
              <div class="w100 overflow-auto depart_tree">
                <el-tree
                  ref="depart_tree"
                  class="self-tree data_tree"
                  node-key="id"
                  show-checkbox
                  default-expand-all
                  check-on-click-node
                  :expand-on-click-node="false"
                  :props="{ children: 'children', label: 'orgName' }"
                  :data="departTree"
                  :check-strictly="true"
                  :filter-node-method="filterNode"
                  @check-change="departCheckChange"
                >
                  <!-- <span
                      slot-scope="{ node }"
                      :title="node.label"
                      class="self-custom-tree"
                    >
                      <span style="padding-right: 10px">{{ node.label }}</span>
                    </span> -->
                </el-tree>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataApi from "@/api/data-permission/dataPermission";
import { mapGetters } from "vuex";
import { commonFilterNode } from "@/utils";

export default {
  name: "PermissionInterface",
  props: {
    targetId: {
      type: String,
      default() {
        return "";
      }
    },
    targetType: {
      type: String,
      default() {
        return "2";
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      saving: false,
      centerSearchText: "",
      defaultProps: {
        children: "children",
        label: "structName"
      },
      departSearchText: "",
      defaultShowNodes: [],
      departTree: [],
      treeData: [],
      loadingTree: false,
      loadingQuick: false,
      centerCurrentNode: "",
      commonResource: {
        resourceId: "",
        dataRulesId: "",
        dataScopeType: "",
        dataScope: []
      },
      treeType: "WEB",
      scopeList: []
    };
  },
  computed: {
    ...mapGetters(["tenantId"])
  },
  watch: {
    targetType() {
      this.getMetaDataTree();
    },
    targetId() {
      this.getMetaDataTree();
    },
    treeType() {
      this.centerSearchText = "";
      this.filterTree();
      this.getMetaDataTree();
    }
  },
  mounted() {
    this.getMetaDataTree();
    this.expandTree(false);
    this.getDepartTree();
    this.getDataScope();
  },
  methods: {
    // 获取数据集查看方式
    getDataScope() {
      const params = {
        operateType: this.disabled ? "VIEW" : "EDIT"
      };
      dataApi.getDataScopeApi(params).then(res => {
        if (res.success) {
          this.scopeList = res.data || [];
        }
      });
    },
    // 获取对象列表
    getMetaDataTree() {
      this.loadingTree = true;
      this.centerCurrentNode = "";
      return dataApi
        .getMetaDataTreeApi({ roleId: this.targetId })
        .then(res => {
          this.loadingTree = false;
          this.topTreeData(res.data);
          this.treeData = res.data;
          this.$nextTick(() => {
            if (!this.centerCurrentNode && res.data && res.data.length) {
              const [node] = res.data;
              this.centerCurrentNode = node;
              this.defaultShowNodes.push(node.id);
              this.getCommonResource();
            }
            if (this.centerCurrentNode) {
              this.$refs.centerTree &&
                this.$refs.centerTree.setCurrentKey(this.centerCurrentNode.id);
              this.centerCurrentNode = this.$refs.centerTree.getCurrentNode();
            }
          });
        })
        .catch(() => {
          this.loadingTree = false;
        });
    },
    /**
     * @description:
     * @param {*} children
     * @return {*}
     */
    topTreeData(treeList) {
      let currentIndex = 0;
      for (let i = 0; i < treeList.length; i++) {
        if (treeList[i].dataScopeTypeName) {
          const middle = treeList[i];
          treeList.splice(i, 1);
          treeList.splice(currentIndex, 0, middle);
          currentIndex++;
        }
        if (treeList[i].children) {
          this.topTreeData(treeList[i].children);
        }
      }
    },
    /**
     * @description:
     * @param {*} children
     * @return {*}
     */
    handleTreeData(children) {
      children.forEach(element => {
        if (this.disabled) {
          element.disabled = true;
        }
        if (element.children) {
          this.handleTreeData(element.children);
        }
      });
    },
    // 获取部门树列表
    getDepartTree() {
      const params = {
        parseToTree: true,
        withUser: true
      };
      if (this.disabled) {
        params["queryAll"] = true;
      }
      dataApi.getOrganization(params, this.tenantId).then(res => {
        this.handleTreeData([res.data]);
        this.departTree = [res.data];
      });
    },
    getCommonResource() {
      this.loadingQuick = true;
      this.commonResource = {
        resourceId: "",
        dataRulesId: "",
        dataScopeType: "",
        dataScope: []
      };
      if (this.disabled) {
        dataApi
          .viewCommonResource(this.centerCurrentNode.id, this.targetId)
          .then(res => {
            this.loadingQuick = false;
            if (res && res.success && res.data) {
              this.commonResource = res.data;
              this.$nextTick(() => {
                this.$refs.depart_tree &&
                  this.$refs.depart_tree.setCheckedKeys(this.commonResource.dataScope);
              });
            }
          })
          .catch(() => {
            this.loadingQuick = false;
          });
      } else {
        dataApi
          .getCommonResource(this.centerCurrentNode.id, this.targetId)
          .then(res => {
            this.loadingQuick = false;
            if (res && res.success && res.data) {
              this.commonResource = res.data;
              this.$nextTick(() => {
                this.$refs.depart_tree &&
                  this.$refs.depart_tree.setCheckedKeys(this.commonResource.dataScope);
              });
            }
          })
          .catch(() => {
            this.loadingQuick = false;
          });
      }
    },
    handleConfrimSave() {
      let type = "ROLE";
      switch (this.targetType) {
        case "1":
          type = "DEPT";
          break;
        case "2":
          type = "ROLE";
          break;
        case "3":
          type = "USER";
          break;

        default:
          break;
      }
      const data = {
        id: this.commonResource.id,
        dataScopeType: this.commonResource.dataScopeType,
        resourceId: this.centerCurrentNode.id,
        targetId: this.targetId,
        dataRulesId: this.commonResource.dataRulesId,
        targetType: type,
        dataScope: this.commonResource.dataScope
      };
      this.saving = true;
      dataApi
        .saveCommonDataApi(data)
        .then(res => {
          this.saving = false;
          if (res && res.success) {
            this.$message({
              message: "保存成功",
              type: "success"
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        })
        .catch(() => {
          this.saving = false;
        });
    },
    /**
     * @description:展开收起菜单树
     * @param {*} expand
     * @return {*}
     */
    expandTree(expand) {
      const { nodesMap } = this.$refs.centerTree.store;
      for (const key in nodesMap) {
        // 全部关闭
        if (key === "-2") {
          nodesMap[key].expanded = true;
        } else {
          nodesMap[key].expanded = expand;
        }
      }
    },

    filterTree() {
      this.$refs.centerTree.filter(this.centerSearchText);
    },
    filterDepartTree() {
      this.$refs.depart_tree.filter(this.departSearchText);
    },
    // 节点筛选
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultShowNodes.push(data.id);
      }
    },
    handleNodeCollapse(data) {
      this.defaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.defaultShowNodes.length = i;
        }
      });
    },

    handleNodeClick(node) {
      this.centerCurrentNode = node;
      this.getCommonResource();
    },
    departCheckChange() {
      this.commonResource.dataScope = this.$refs.depart_tree.getCheckedKeys();
    }
  }
};
</script>

<style scoped lang="scss">
#source_permission_data {
  width: 100%;
  height: 100%;
  display: flex;
  .left_tree_box {
    width: 224px;
    margin-left: 0;
    transition: all 0.25s linear;
    background-color: #f9f9fb;
    position: relative;
    .data_tree {
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      .el-icon-more {
        transform: rotate(90deg);
      }
    }
    .data_tree::-webkit-scrollbar {
      width: 0 !important;
    }
  }

  .fade-left-enter-active,
  .fade-left-leave-active {
    transition: all 0.2s ease-in;
    flex: 0 224px;
  }

  .fade-left-enter-from,
  .fade-left-leave-to {
    flex: 0 0;
  }
  .tree_content {
    display: flex;
    flex: 1;
    transition: all 0.2s ease-in;
    min-width: calc(100% - 324px);
    .center_tree_box {
      position: relative;
      flex: 0 244px;
      width: 324px;
    }
    .right_content {
      flex: 1;
      height: 100%;
      padding-left: 16px;
      padding-right: 24px;
      width: calc(100% - 324px);

      .content_box {
        width: 100%;
        height: calc(100% - 48px);
      }
    }
  }

  .plain_button {
    color: #505363;
    background-color: #fff;
    border-color: #9da5b2;
  }

  .depart_tree {
    height: calc(100% - 60px);
  }
}
</style>

<style lang="scss">
#source_permission_data {
  .el-radio-group {
    margin-top: 0px;
  }
  .el-radio {
    height: 32px;
  }
  .self-filter-input {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
    .el-input__icon {
      color: #9da5b2;
      line-height: 32px;
    }
  }
  .el-radio-button {
    margin-top: 0px;
    .el-radio-button__inner {
      padding: 8px 10px;
      width: 88px;
      font-size: 14px;
    }
  }

  .tree_height {
    height: calc(100% - 110px);
  }

  .table_wrap {
    height: calc(100% - 180px);
  }
  .tree-tabs-wrapper {
    .el-radio-button {
      .el-radio-button__inner {
        width: 103px;
        font-size: 12px;
      }
    }
  }
}
</style>
